import * as React from "react";
import { Input, Modal, notification } from "antd";
import { linksOf, request } from "../../../services/cpln";
import { DeleteVolumeReducerState, useRunDeleteVolumeReducer } from "./reducer_deleteVolume";
import { VolumeSet } from "../../../schema/types/volumeSet/entity";

interface Props {
  volumeSet: VolumeSet;
  initialLocation?: string;
  initialVolumeIndex?: string;
  onClose: any;
  onDone: any;
  visible: boolean;
}

export const CommandModal_DeleteVolume: React.FC<Props> = ({
  volumeSet,
  initialLocation,
  initialVolumeIndex,
  onClose,
  onDone,
  visible,
}) => {
  const selfLink = linksOf(volumeSet).self!;
  const [confirmationText, setConfirmationText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const [state] = useRunDeleteVolumeReducer(initialLocation, initialVolumeIndex);

  const CONFIRMATION_TOKEN = React.useMemo(() => {
    return `${volumeSet.name}/${state.location}/${state.volumeIndex}`;
  }, [volumeSet.name, state.location, state.volumeIndex]);

  async function handleConfirm() {
    try {
      setIsLoading(true);

      const spec: DeleteVolumeReducerState = JSON.parse(JSON.stringify(state));

      await request({
        method: "post",
        url: `${selfLink}/-command`,
        body: {
          type: "deleteVolume",
          spec: spec,
        },
      });
      onDone();
      notification.success({
        message: "Success",
        description: "Created Command.",
      });
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      notification.warning({
        message: "Failed",
        description: errorMessage,
      });
      setIsLoading(false);
    }
  }

  let isValid = true;
  if (!state.location) isValid = false;
  if (!state.volumeIndex) isValid = false;
  if (confirmationText !== CONFIRMATION_TOKEN) isValid = false;

  return (
    <Modal
      open={visible}
      title="Delete Volume"
      okText={`Delete`}
      cancelButtonProps={{ type: "default", danger: false, disabled: isLoading }}
      okButtonProps={{ type: "primary", danger: true, disabled: isLoading || !isValid, loading: isLoading }}
      onCancel={onClose}
      onOk={handleConfirm}
      maskClosable={false}
      destroyOnHidden
    >
      <div className="flex flex-col gap-2">
        <div>Are you sure you want to delete this volume?</div>
        <div className="delete-modal-confirmation-warning mt-4">{`Type "${CONFIRMATION_TOKEN}" for confirming the delete action`}</div>
        <Input
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          placeholder={`confirmation`}
        />
      </div>
    </Modal>
  );
};
